/*
 * Copyright (c) 2023 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Thursday, August 10th 2023, 9:56:29 am
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import { useNavigate } from "react-router-dom";
import { resolveURLName } from "core/routes/utils";
import { FormConfiguration } from "lib/schemas";

export const useNavigateToFormBuilder = () => {
  const navigate = useNavigate();

  const navigateToFormBuilder = (formId: FormConfiguration["id"]) => {
    const formBuilderURL = resolveURLName("formBuilder", { formId });
    navigate(formBuilderURL);
  };

  return { navigateToFormBuilder };
};
